module.exports = ".sidebar-form {\n    margin: 6px 15px 0px 15px;\n    overflow: inherit;\n}"